/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgApex = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="m11.866 4.888-3.283-3.3-7 6.916 3.323 3.337 1.415-1.413-1.904-1.912 4.154-4.104.684.688L7.87 6.486l1.198 1.197zM2 17.572V22h4.43L22.01 6.435l-4.431-4.427zm2 .83 10.059-10.05L15.66 9.95 5.602 20H4zm13.075-9.865-1.601-1.6 2.104-2.102 1.6 1.6zm-4.927 10.577 1.415-1.414 1.88 1.888 4.138-4.1-.68-.68-2.756 2.755-1.221-1.222 4.172-4.169.51.516.005.005 2.808 2.799-6.986 6.92z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgApex as Apex };
